// CsvColumnMapper.tsx
import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const CsvColumnMapper = ({
  modelColumns,
  csvColumns,
  onCsvUpload,
  mappings,
  setMappings,
  unmatched,
  onRefresh,
  onSeparatorChange,
}) => {
  const [separator, setSeparator] = useState("|");

  const handleSeparatorChange = (e) => {
    setSeparator(e.target.value);
    onSeparatorChange?.(e.target.value);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      const firstLine = text.split(/\r?\n/)[0];
      const cols = firstLine.split(separator).map((c) => c.trim());
      onCsvUpload(cols, file, separator);
    };
    reader.readAsText(file);
  };

  const handleMappingChange = (col, value) => {
    setMappings((prev) => ({ ...prev, [col]: value }));
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 ">

        {/* Separator */}
        <div className="flex flex-col-sm gap-4">
          <label className="font-semibold">Separator</label>
          <input
            type="text"
            value={separator}
            onChange={handleSeparatorChange}
            maxLength={1}
            placeholder="Separator"
            className="border p-2 w-24"
          />
        </div>

        {/* CSV File Input */}
        <div className="flex flex-col-sm gap-4">
          <label className="font-semibold">Upload CSV</label>
          <input type="file" accept=".csv" onChange={handleFileSelect} />
        </div>

      </div>

      {/* Dynamic Table */}
      <div>
        <table className="w-full border text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2 text-left">Model Column</th>
              <th className="border p-2 text-left">CSV Column</th>
            </tr>
          </thead>
          <tbody>
            {modelColumns.map((col) => (
              <tr key={col}>
                <td className="border p-2">{col}</td>
                <td className="border p-2">
                  <input
                    type="text"
                    value={mappings[col] || ""}
                    onChange={(e) => handleMappingChange(col, e.target.value)}
                    className="border p-2 w-full"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Refresh Button */}
      <Button
        onClick={onRefresh}
        className="w-full sm:w-auto sm:ml-auto bg-intellend-green hover:bg-intellend-green/90 h-9"
      >
        Refresh Remaining Columns
      </Button>

      {/* Remaining Columns Section */}
      {unmatched.length > 0 && (
        <div className="p-3 border rounded bg-gray-50">
          <div className="font-semibold mb-2">Remaining CSV Columns</div>
          <div className="text-sm">{unmatched.join(", ")}</div>
        </div>
      )}
    </div>
  );
};

export default CsvColumnMapper;
